export { default } from './EventDetails';
